import { useReviewHistory } from './queries';

export function ReviewHistoryPanel({ tradeId }: { tradeId: string }) {
  const history = useReviewHistory(tradeId);

  if (history.isLoading) return <p className="text-sm text-text-muted">Loading history...</p>;
  if (!history.data || history.data.length === 0) {
    return <p className="text-sm text-text-muted">No prior revisions.</p>;
  }

  return (
    <div className="space-y-3">
      {history.data.map((item) => (
        <article key={item.id} className="rounded border border-border bg-bg-muted p-3">
          <div className="text-xs font-semibold text-text-muted">
            Revision {item.revision} replaced {new Date(item.replacedAt).toLocaleString()}
          </div>
          <pre className="mt-2 max-h-48 overflow-auto whitespace-pre-wrap text-xs text-text-muted">
            {JSON.stringify(item.snapshot, null, 2)}
          </pre>
        </article>
      ))}
    </div>
  );
}
